import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../../../redux/actions/auth";
import ProfileAvatar from "../ProfileAvatar";
import styles from "./ProfileCard.module.css";

// Nombre visible de cada rol (Usuario.TIPO_CHOICES en el backend)
const TIPO_LABELS = {
  profesor: "Profesor",
  panolero: "Pañolero",
  admin: "Administrador",
};

// Para mostrar un dato nuevo en el perfil basta con agregar una entrada aquí.
const PROFILE_FIELDS = [
  { key: "nombre", label: "Nombre", get: (user) => user.nombre },
  { key: "email", label: "Correo", get: (user) => user.email },
  { key: "tipo", label: "Tipo", get: (user) => TIPO_LABELS[user.tipo] || user.tipo },
];

const ProfileCard = ({ user, logout }) => {
  const handleLogout = () => {
    logout();
    window.location.href = "/";
  };
  return (
    <section className={styles.card}>
      <h2 className={styles.title}>Mi perfil</h2>
      {!user ? (
        <p>Cargando...</p>
      ) : (
        <>
          <div className={styles.content}>
            <ProfileAvatar alt={`Foto de perfil de ${user.nombre || "usuario"}`} />
            <dl className={styles.data}>
              {PROFILE_FIELDS.map(({ key, label, get }) => (
                <div className={styles.row} key={key}>
                  <dt className={styles.label}>{label}</dt>
                  <dd className={styles.value}>{get(user) || "—"}</dd>
                </div>
              ))}
            </dl>
          </div>
          <div className={styles.actions}>
            <Link className={`${styles.btn} ${styles.btnPrimary}`} to="/CambioContrasena">
              Cambiar contraseña
            </Link>
            <button type="button" className={`${styles.btn} ${styles.btnSecondary}`} onClick={handleLogout}>
              Cerrar sesión
            </button>
          </div>
        </>
      )}
    </section>
  );
};

const mapStateToProps = (state) => ({
  user: state.Auth.user,
});

export default connect(mapStateToProps, { logout })(ProfileCard);
